module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-down-+.366e47ef.svg";